<template>
    <tr>
        <th scope="col"
            :class="[
                'leading-tight',
                getClass(column),
                {'scroller-fixed-column': index === 0}
            ]"
            @click="sort(column)"
            v-for="(column, index) in columns"
            :key="column"
            :data-type="column.label"
            >
                {{ column.label }}

                <div class="inline-block" v-if="isActive(column)">
                    <i v-if="sortDirection === 'asc'" class="fa fa-caret-down"></i>
                    <i v-if="sortDirection === 'desc'" class="fa fa-caret-up"></i>
                </div>
        </th>
    </tr>
</template>

<script setup>
import { ref } from 'vue';

// Props
const props = defineProps({
    columns: Array,
    sortDirection: String
});

// const emit = defineEmits(['sort']);
const emit = defineEmits();
const active = ref(false);

// Methods
const sort = (column) => {
    if (column.sortable) {
        emit('sort', column);
        active.value = column;
    }
};

const isActive = (column) => {
    return column === active.value;
};

const getClass = (column) => {
    if (isActive(column)) {
        return `font-semibold`;
    }
};

</script>
